SlideView = require("views/slide")
device     = require("lib/device")

# This video JS is not loaded by slide.coffee to be able to control 
class VideoView extends SlideView
  template: require("./template")

  events: ->
    "iostap .btn-done": "next"

  initialize: ->
    super

    @options.data.showSkipButton ?= true

    if @options.data.prompt is ""
      @options.data.prompt = require("./model").model.prompt.default

  serialize: ->
    data = super

    data.continueBtnText = i18n("video.skip-video")
    data.hasPrompt = not data.showSkipButton

    data

  show: ->
    return if not @options.data.url

    videoJsPlayer = @el.querySelector(".video-js")
    if videoJsPlayer
      id = videoJsPlayer.getAttribute("id")
      @player = _.findWhere(@players, { id_: id })
      if @player
        @player.ready =>
          @setState("success", "video")
          if @options.data.autoplay and window.location.href.split("thumbnail=true").length isnt 2
            @player.play()
          if not @options.data.showSkipButton
            @player.on "timeupdate", _.bind(@onTimeUpdate, this)
            @player.on "seeking", _.bind(@onSeeking, this)

        @player.on "ended", _.bind(@onVideoEnd, this)

  beforeShow: (lmsMode) ->
    if lmsMode
      @options.data.autoplay = !lmsMode

    @trigger("ui", lightbox: true, flexibleHeight: true)

    if device.platform != "browser"
      Application.publish("event:rotation-unlock") {}

  beforeHide: ->
    @trigger("ui", lightbox: false, flexibleHeight: false)
    if device.platform != "browser"
      Application.publish("event:rotation-lock") {}

  onRefresh: ->
    @beforeShow(true)
    super

  onVideoEnd: ->
    @findOne(".btn-done").innerHTML = i18n("buttons.continue")
    @setState("touched") unless @options.data.showSkipButton

    @lesson.processInteraction
      type: "video"
      event: name: "video-watched"
      metadata: @options.metadata
    if @options.data.autoprogress
      @submit()

  onTimeUpdate: ->
    unless @player.scrubbing() or @player.seeking()
      @timeBeforeChange = @player.currentTime()

  onSeeking: ->
    if @currentState.state isnt "touched" and @player.currentTime() > @timeBeforeChange
      @player.currentTime(@timeBeforeChange)

module.exports = VideoView